module.exports = __webpack_public_path__ + "media/images/nutrition_lab-f6597c19.jpg";